import { shouldShowVeloHeader } from '../../../utils';

export const internalTopBarLinks = [
  { name: 'API Reference', url: 'https://bo.wix.com/wix-docs', active: true }, // we are always inside API reference pages when presenting the top bar
  { name: 'SDK', url: 'http://dev.wix.com/docs' },
  {
    name: 'RPC API Explorer',
    url: 'https://pbo.wixpress.com/wix-api-explorer',
  },
  { name: 'RPC Console', url: 'https://pbo.wixpress.com/rpc-console-poc' },
  { name: 'GRPC Console', url: 'https://pbo.wix.com/fire-console' },
];

export const veloTopBarLinks = [
  {
    name: 'API Reference',
    url: 'https://www.wix.com/velo/reference',
    active: true,
  },
  { name: 'Videos', url: 'https://www.wix.com/velo/video-tutorials' },
  {
    name: 'Examples',
    url: 'https://www.wix.com/velo/examples',
  },
  { name: 'Articles', url: 'https://support.wix.com/en/velo-by-wix/basics' },
  { name: 'Forum', url: 'https://www.wix.com/velo/forum' },
];

const HEADER_TYPES = {
  internal: 'internal',
  velo: 'velo',
};

const links = {
  [HEADER_TYPES.internal]: internalTopBarLinks,
  [HEADER_TYPES.velo]: veloTopBarLinks,
};

export const getLinks = (viewerCategory) => {
  if (shouldShowVeloHeader(viewerCategory)) {
    return links[HEADER_TYPES.velo];
  }
  return [];
};
